
<template>

  <el-tooltip v-if="title" :content="title" placement="top" :enterable="false" :hide-after="0">
    <div :id="id" class="overflow-tooltip" :style="{maxWidth:maxWidth}">
      {{ content }}
    </div>
  </el-tooltip>
  <div v-else :id="id" class="overflow-tooltip" :style="{maxWidth:maxWidth}">
    {{ content }}
  </div>
</template>
 
<script>
export default {
  props: {
    content: [String, Number, Boolean],
    maxWidth: { type: String }
  },
  data() {
    return {
      title: '',
      id: Math.random().toString(36).slice(2)
    }
  },
 
  mounted() {
    const el = document.getElementById(this.id);
    const elComputed = document.defaultView.getComputedStyle(el, '');
    const padding =
      parseInt(elComputed.paddingLeft.replace('px', '')) +
      parseInt(elComputed.paddingRight.replace('px', ''))
 
    const range = document.createRange();
    range.setStart(el, 0);
    range.setEnd(el, el.childNodes.length);
    const rangeWidth = range.getBoundingClientRect().width;
 
    if (
      rangeWidth + padding > el.offsetWidth ||
      el.scrollWidth > el.offsetWidth
    ) {
      this.title = this.content;
    }
  }
}
</script>
 
<style scoped>
.overflow-tooltip {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}
</style>